// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__9G-sp","flex":"Navigation_flex__qUlQ2","menuButton":"Navigation_menuButton__dFEhp","LogoContainer":"Navigation_LogoContainer__niP7L"};